import { __values } from "tslib";
import { formatFabricCompositionForHtml } from '../utils/formatFabricCompositionForHtml';
var Style = /** @class */ (function () {
    function Style() {
        this.masterId = '';
        this.colorCode = '';
        this.description = '';
        this.colorName = '';
        this.collectionName = '';
        this.collectionSortCode = 0;
        this.discontinued = false;
        this.seasonCode = '';
        this.oekotex = '';
        this.gots = '';
        this.productGroup = '';
        this.productGroupSort = 0;
        this.productCategory = '';
        this.styleComment = '';
        this.colorComment = '';
        this.styleNote = '';
        this.colorNote = '';
        this.fabricComposition = '';
        this.qualityCategory = '';
        this.totalDisp = 0;
        this.colorBlocked = 0;
        this.masterColor = '';
        this.whp = 0;
        this.msrp = 0;
        this.currencyCode = '';
        this.navCollection = '';
        this.orderType = '';
        this.recycled = false;
        this.b2BColorComment = '';
        this.b2BMasterComment = '';
        this.priceType = '';
        this.organic = false;
        this.ecovero = false;
        this.subCategories = [];
        this.junior = false;
        this.baby = false;
        this.youth = false;
        this.ocsno = '';
        this.grsno = '';
        this.ocsblended = '';
        this.totalcolorsold = 0;
        this.totalmastersold = 0;
        this.qtysbbaskets = 0;
        this.qtyb2bbaskets = 0;
    }
    Style.prototype.getWHPWithDiscount = function (discount) {
        return this.whp - (this.whp * (discount / 100));
    };
    return Style;
}());
/** True when API/DB marks the color variant as blocked (handles int, bool, string). */
export function isColorBlocked(style) {
    if (!style) {
        return false;
    }
    var value = style.colorBlocked;
    return value === 1 || value === true || value === '1';
}
function readColorBlocked(data) {
    if (data == null) {
        return 0;
    }
    if (data.colorBlocked != null) {
        return isColorBlocked({ colorBlocked: data.colorBlocked }) ? 1 : Number(data.colorBlocked) || 0;
    }
    if (data.ColorBlocked != null) {
        return isColorBlocked({ colorBlocked: data.ColorBlocked }) ? 1 : Number(data.ColorBlocked) || 0;
    }
    return 0;
}
export function createStyle(data) {
    var _a, _b;
    var style = new Style();
    // console.log('bo-larsen Creating the style from data');
    style.masterId = data.masterid;
    style.colorCode = data.colorcode;
    style.description = data.description;
    style.discontinued = data.discontinued || false;
    style.colorName = data.colorname;
    style.collectionName = data.collectionname;
    style.collectionSortCode = data.collectionsortcode;
    // style.deliveryWindow = data.deliverywindow;
    // style data.deliveryprint,
    // data.deliverysort,
    style.seasonCode = data.seasoncode;
    style.oekotex = data.oekoTex;
    style.gots = data.gots;
    style.ocsno = data.ocsno || '';
    style.grsno = data.grsno || '';
    style.ocsblended = data.ocsblended || '';
    style.productGroup = data.productgroup;
    style.productGroupSort = data.productgroupsort;
    style.productCategory = data.productcategory;
    style.styleComment = data.styleComment;
    style.colorComment = data.colorComment;
    style.styleNote = data.styleNote;
    style.colorNote = data.colorNote;
    style.fabricComposition = formatFabricCompositionForHtml(data.fabricComposition);
    style.qualityCategory = data.qualityCategory;
    style.totalDisp = data.totalDisp;
    style.colorBlocked = readColorBlocked(data);
    style.masterColor = data.mastercolor;
    style.whp = data.whp;
    style.msrp = data.msrp;
    style.currencyCode = data.currencyCode;
    // style.deldata .deliveryshipmentdate,
    style.navCollection = data.navcollection;
    style.orderType = (_b = (_a = data.orderType) !== null && _a !== void 0 ? _a : data.ordertype) !== null && _b !== void 0 ? _b : '',
        style.recycled = data.recycled;
    style.b2BColorComment = data.b2BColorComment;
    style.b2BMasterComment = data.b2BMasterComment;
    style.priceType = data.hasDifferentialPrice === 1 ? 'Diff' : 'NoDiff';
    style.organic = data.organic;
    style.ecovero = data.ecovero;
    style.junior = data.junior;
    style.baby = data.baby;
    style.youth = data.youth;
    // style.deliveryWindow = {
    //     print: data.deliveryprint,
    //     sort: 0,
    //     window: data.deliverywindow,
    //     shipmentDate: new Date(),
    //     label: data.deliveryprint,
    //     originalWindow: data.deliverywindow
    // }
    var deliveryShipmentDate = data.deliveryshipmentdate;
    var shipmentDate = new Date(deliveryShipmentDate);
    // if (Math.floor(Math.random() * 10) < 7) {
    //     shipmentDate = new Date('2020-10-10')
    // }
    var today = new Date();
    style.deliveryWindow = {
        print: data.deliveryPrint,
        sort: shipmentDate > today ? data.deliverysort : 0,
        window: shipmentDate <= today ? 'available now' : data.deliverywindow,
        shipmentDate: shipmentDate,
        label: shipmentDate > today ? data.deliveryprint : 'available now',
        originalWindow: data.deliverywindow
    };
    return style;
}
export function createStyleFromSalesbookMoloMaster(data) {
    var style = new Style();
    // console.log('bo-larsen Creating the style from createStyleFromSalesbookMoloMaster');
    style.masterId = data.masterid;
    style.colorCode = data.colorcode;
    style.description = data.description;
    style.discontinued = data.discontinued || false;
    style.colorName = data.colorname;
    style.collectionName = data.collectionname;
    style.collectionSortCode = data.collectionsortcode;
    // style.deliveryWindow = data.deliverywindow;
    // style data.deliveryprint,
    // data.deliverysort,
    style.seasonCode = data.seasoncode;
    style.oekotex = data.OekoTex;
    style.gots = data.GOTS;
    style.grsno = data.GRSno;
    style.ocsno = data.OCSno;
    style.ocsblended = data.ocsblended || '';
    style.productGroup = data.productgroup;
    style.productGroupSort = data.productgroupsort;
    style.productCategory = data.productcategory;
    // style.styleComment = data.StyleComment;
    // style.colorComment = data.ColorComment;
    style.styleComment = data.StyleComment ? data.StyleComment.split(",").join("<br/>") : '';
    style.colorComment = data.ColorComment ? data.ColorComment.split(",").join("<br/>") : '';
    style.styleNote = data.StyleNote;
    style.colorNote = data.ColorNote;
    style.fabricComposition = formatFabricCompositionForHtml(data.FabricComposition);
    style.qualityCategory = data.QualityCategory;
    style.totalDisp = data.totalDisp;
    style.colorBlocked = readColorBlocked(data);
    style.masterColor = data.mastercolor;
    style.deliveryWindow = {
        print: data.deliveryprint,
        sort: 0,
        window: data.deliverywindow,
        shipmentDate: new Date(),
        label: data.deliveryprint,
        originalWindow: data.deliverywindow
    };
    // style.whp = data.whp;
    // style.msrp = data.msrp;
    // style.currencyCode = data.currencyCode;
    // style.deldata .deliveryshipmentdate,
    // style.navCollection = data.navcollection;
    // style.orderType = data.orderType,
    style.recycled = data.recycled;
    // style.b2BColorComment = data.b2BColorComment;
    // style.b2BMasterComment = data.b2BMasterComment;
    // style.has data.hasDifferentialPrice === 1 ? 'Diff' : 'NoDiff',
    style.organic = data.organic;
    style.ecovero = data.ecovero;
    style.junior = data.junior;
    style.baby = data.baby;
    style.youth = data.youth;
    return style;
}
export var createStyleFromSalesbbok = function (data) {
    var style = new Style();
    console.log(data, 'new style created');
    style.masterId = data.masterid;
    style.colorCode = data.colorcode;
    style.description = data.description;
    style.discontinued = data.discontinued || false;
    style.colorName = data.colorname;
    style.collectionName = data.collectionname;
    style.collectionSortCode = data.collectionsortcode;
    style.totalcolorsold = data.totalcolorsold;
    style.totalmastersold = data.totalmastersold;
    style.qtyb2bbaskets = data.qtyb2bbaskets;
    style.qtysbbaskets = data.qtysbbaskets;
    // style.deliveryWindow = data.deliverywindow;
    // style data.deliveryprint,
    style.seasonCode = data.seasoncode;
    style.oekotex = data.OekoTex;
    style.gots = data.GOTS;
    style.ocsno = data.ocsno;
    style.grsno = data.grsno;
    style.ocsblended = data.ocsblended;
    style.productGroup = data.productgroup;
    style.productGroupSort = data.productgroupsort;
    style.productCategory = data.productcategory;
    // style.styleComment = data.StyleComment;
    // style.colorComment = data.ColorComment;
    style.styleComment = data.StyleComment ? data.StyleComment.split(",").join("<br/>") : '';
    style.colorComment = data.ColorComment ? data.ColorComment.split(",").join("<br/>") : '';
    style.styleNote = data.StyleNote;
    style.colorNote = data.ColorNote;
    style.fabricComposition = formatFabricCompositionForHtml(data.FabricComposition);
    style.qualityCategory = data.QualityCategory;
    style.totalDisp = data.totalDisp;
    style.colorBlocked = readColorBlocked(data);
    style.masterColor = data.mastercolor;
    style.deliveryWindow = {
        print: data.deliveryprint,
        sort: data.deliverysort,
        window: data.deliverywindow,
        shipmentDate: new Date(),
        label: data.deliveryprint,
        originalWindow: data.deliverywindow
    };
    // style.whp = data.whp;
    // style.msrp = data.msrp;
    // style.currencyCode = data.currencyCode;
    // style.deldata .deliveryshipmentdate,
    // style.navCollection = data.navcollection;
    // style.orderType = data.orderType,
    style.recycled = data.recycled;
    // style.b2BColorComment = data.b2BColorComment;
    // style.b2BMasterComment = data.b2BMasterComment;
    // style.has data.hasDifferentialPrice === 1 ? 'Diff' : 'NoDiff',
    style.organic = data.organic === 1;
    style.ecovero = data.ecovero === 1;
    style.junior = data.junior === 1;
    style.baby = data.baby === 1;
    style.youth = data.youth === 1;
    return style;
};
export function mapStyles(data) {
    var e_1, _a;
    var mapped = [];
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var style = data_1_1.value;
            var newStyle = createStyle(style);
            if (!isColorBlocked(newStyle)) {
                mapped.push(newStyle);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return mapped;
}
export function mapStylesFromSalesBook(data) {
    var e_2, _a;
    var mapped = [];
    try {
        // Keep blocked styles so salesbook can toggle "Show blocked items only".
        for (var data_2 = __values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
            var style = data_2_1.value;
            mapped.push(createStyleFromSalesbbok(style));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mapped;
}
export default Style;
//# sourceMappingURL=Style.js.map